<template>
  <g class="not-copy">
    <GreenGrassOfficeR :width="width" :height="height" :virtualOfficeRoom="officeType.virtual_office_room" v-if="officeType.office === 0"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import GreenGrassOfficeR from '@/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR'
export default {
  name: 'Room',
  componentName: 'Room',
  props: ['width', 'height', 'officeType'],
  components: {
    GreenGrassOfficeR
  },
  data () {
    return {
      stroke: '#fff',
      strokeWidth: 10,
      fill: '#505b66',
      wholeH: 600,
      wholeW: 1400,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Room.vue